module.exports = __webpack_public_path__ + "static/media/mabrypro.091d5ea7.woff2";